"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentRegistry = new Set();
exports.default = exports.componentRegistry;
//# sourceMappingURL=component_registry.js.map